export const actions = {
  add: 'ADD_PROGRAMS_TO_CHANNEL',
  addToSpecific: 'ADD_PROGRAMS_TO_SPECIFIC_CHANNEL',
  update: 'UPDATE_PROGRAM_OF_CHANNEL',
};

/**
 * Add programs action
 * @param  {Object[]} channels channels with event property which contains the programs to add
 * @return {Object}         Action to add programs to channels
 */
export const addProgramsToChannels = channels => ({
  type: actions.add,
  channels: channels,
});

export const addProgramsToSpecificChannel = (sid, programs) => ({
  type: actions.addToSpecific,
  sid: sid,
  programs: programs,
});

export const updateProgram = (sid, uuid, data) => ({
  type: actions.update,
  sid: sid,
  uuid: uuid,
  data: data,
});
